﻿import axios from 'axios';

const websiteApiBaseUrl = (import.meta.env.VITE_WEBSITE_API_BASE_URL || 'https://api.beautysports.in/website-api').replace(/\/$/, '');

export interface WebsiteSettings {
  general?: {
    storeName?: string;
  };
  store?: {
    legalName?: string;
    address?: string;
    city?: string;
    state?: string;
    postalCode?: string;
  };
  website?: {
    footerDescription?: string;
    footerEmail?: string;
    footerPhone?: string;
    facebookUrl?: string;
    instagramUrl?: string;
    youtubeUrl?: string;
    whatsappNumber?: string;
  };
}

export async function getWebsiteSettings(): Promise<WebsiteSettings | null> {
  const response = await axios.get<{ data: WebsiteSettings }>(websiteApiBaseUrl + '/settings');
  return response.data.data || null;
}

